import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import cx from 'classnames';
//import Tree from 'react-ui-tree';
import randomstring from 'uuid/v4';
import Tree from '../../../tree/Index';

import Chip from '@material-ui/core/Chip';

import { AddIcon } from '../../../../images/icons/WrapSvg';

import RolsOptions from './RolOptions';

// eslint-disable-next-line
import style from './_style.css';

class Employee extends React.Component {
    state = {
        cliente: this.props.cliente,
        permisos: this.props.permisos,
        selected: undefined,
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            cliente: nextProps.cliente,
            permisos: nextProps.permisos,
        });
    }

    handleCloseDialog = (selection) => {
        const { permisos, selected } = this.state;
        if (selection) {
            let local = permisos.find(
                (f) => f.idlocal === (selected.idlocal ? selected.idlocal : null),
            );
            local.rol = selection.map((rol) => {
                return {
                    id: rol.id,
                    nombre: rol.name,
                };
            });
            local.idrol = selection.map((rol) => rol.id);
        }
        this.props.onChange(permisos);
        this.setState({ selected: undefined, permisos: permisos });
    };

    handleChipDelete = (node, rol, add) => (event) => {
        if (add) {
            const { permisos } = this.state;
            const local = permisos.find((f) => f.idlocal === (node ? node : null));
            if (local) {
                let index = local.rol.map((r) => r && r.id).indexOf(rol);
                if (index >= 0) {
                    local.rol.splice(index, 1);
                }
                index = local.idrol.indexOf(rol);
                if (index >= 0) {
                    local.idrol.splice(index, 1);
                }
            }
            this.props.onChange(permisos);
            this.setState({ permisos: permisos });
        }
    };

    handleAddRol = (id) => (event) => {
        event.preventDefault(); // Let's stop this event.
        event.stopPropagation(); // Really this time.
        const { permisos } = this.state;
        let local = permisos.find((f) => f.idlocal === (id ? id : null));
        if (!local) {
            local = {
                idlocal: id ? id : null,
                rol: [],
                idrol: [],
                idusuario: this.props.idusuario,
            };
            permisos.push(local);
        }
        this.setState({ selected: local, permisos: permisos });
    };

    renderNode = (node) => {
        const { info } = this.props;
        const add =
            node &&
            node.id &&
            info &&
            info.security &&
            info.security.localPermits &&
            info.security.localPermits[node.id.toString()]
                ? info.security.localPermits[node.id.toString()].some(
                      (r) => r === '20' || r === '64',
                  )
                : info && info.security && info.security.globalPermits
                ? info.security.globalPermits.some((r) => r === '20' || r === '64')
                : undefined;
        if(add || node.children.length > 0) {
            return (
                <div
                    className="flex_full_column "
                    onMouseDown={function(e) {
                        e.stopPropagation();
                    }}
                >
                    <div
                        className={
                            'flex_auto_row bg_grey_blue c_white padding_right_12 align_center row'
                        }
                    >
                        <span
                            className={
                                'barlow_regular_small flex_full_row padding_top_12 padding_bottom_12 padding_left_24'
                            }
                            onMouseDown={function(e) {
                                e.stopPropagation();
                            }}
                        >
                            {node.name}
                        </span>
                        {add && (
                            <AddIcon
                                onClick={this.handleAddRol(node.id)}
                                onMouseDown={function(e) {
                                    e.stopPropagation();
                                }}
                            />
                        )}
                    </div>
                    <div
                        className={cx(
                            'flex_full_row wrap',
                            node.rols && node.rols.length > 0 ? 'padding_top_12 padding_bottom_12' : '',
                        )}
                        onMouseDown={function(e) {
                            e.stopPropagation();
                        }}
                    >
                        {node.rols &&
                            node.rols
                                .sort((a, b) => (a && b && a.nombre < b.nombre ? -1 : 1))
                                .map((t) => {
                                    if (t) {
                                        return (
                                            <Chip
                                                key={randomstring()}
                                                label={t.nombre}
                                                onDelete={this.handleChipDelete(node.id, t.id, add)}
                                                onMouseDown={function(e) {
                                                    e.stopPropagation();
                                                }}
                                                className="margin_left_12 chip c_white bg_bluish"
                                            />
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                    </div>
                </div>
            );
        } else {
            return <div className="hide" />;
        }
    };

    renderCollapse = (collapsed) => {
        return (
            <span
                className={cx(
                    'collapse padding_top_12 c_white ',
                    collapsed ? 'caret-right' : 'caret-down',
                )}
                onMouseDown={function(e) {
                    e.stopPropagation();
                }}
                onClick={this.handleCollapse}
            />
        );
    };

    findRols = (id, permisos) => {
        return permisos
            ? permisos
                  .filter((f) => f.idlocal === (id ? parseInt(id, 10) : null))
                  .reduce((arr, p) => {
                      arr = arr.concat(p.rol);
                      return arr;
                  }, [])
            : [];
    };

    isToShow = (n) => {
        const {info} = this.props;
        return n.hijos &&  n.hijos.length > 0 
                ? n.hijos.reduce((toShow, h) => { toShow = toShow || this.isToShow(h); return toShow; }, false) 
                :  info &&
                    info.security &&
                    info.security.localPermits &&
                    info.security.localPermits[n.id.toString()]
                        ? info.security.localPermits[n.id.toString()].some( (r) => r === '20' || r === '64')
                        : info && info.security && info.security.globalPermits
                            ? info.security.globalPermits.some((r) => r === '20' || r === '64')
                            : undefined;
    };

    processRecursiveLocasl = (nodes, permisos) => {
        return nodes
            .sort((a, b) => a.nombre > b.nombre ? 1 : -1)
            .reduce((array, n) => {
                const toShow = this.isToShow(n);
                if(toShow) {
                    array.push( {
                        id: n.id,
                        name: n.nombre,
                        children:
                                toShow && n.hijos && n.hijos.length > 0
                                ? this.processRecursiveLocasl(n.hijos, permisos)
                                : [],
                        rols: this.findRols(n.id, permisos),
                    })
                }
                return array;
            }, []);
    };

    processTreeLocals = (intl, cliente, permisos) => {
        const childs = this.processRecursiveLocasl(cliente.hijos, permisos);
        const client = [
            {
                id: cliente.id,
                name: cliente.nombre,
                children: childs,
                rols: this.findRols(cliente.id, permisos),
            },
        ];
        return {
            id: null,
            name: intl.formatMessage({ id: 'global' }),
            children: client,
            rols: this.findRols(null, permisos),
        };
    };

    render() {
        const { cliente, permisos, selected } = this.state;
        const { intl } = this.props;
        const tree =
            cliente && cliente.hijos && cliente.hijos.length > 0
                ? this.processTreeLocals(intl, cliente, permisos)
                : undefined;
        if (tree) {
            return (
                <div className="flex_full_column">
                    <div className="flex_auto_row margin_bottom_24">
                        <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                            <FormattedMessage id="rols" />
                        </div>
                    </div>
                    <div className={'flex_full_row roltree'}>
                        {tree && (
                            <Tree
                                paddingLeft={40} // left padding for children nodes in pixels
                                tree={tree}
                                renderNode={this.renderNode} // renderNode(node) return react element
                                renderCollapse={this.renderCollapse}
                                isNodeCollapsed={this.isNodeCollapsed}
                            />
                        )}
                    </div>
                    {selected !== undefined && (
                        <RolsOptions
                            onClose={this.handleCloseDialog.bind(this)}
                            values={selected.rol.map((r) => r && r.id)}
                        />
                    )}
                </div>
            );
        } else {
            return null;
        }
    }
}

Employee.propTypes = {
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        info: state.info,
    };
};

Employee = connect(
    mapStateToProps,
    null,
)(Employee);

Employee = injectIntl(Employee);

export default Employee;



// WEBPACK FOOTER //
// ./src/components/complex/manage/user/Tree.js